'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});


// # Example
// events:
//   Added Credit Card:
//     mapTo: Credit Card Added
//   Billing Plan Clicked:
//     mapTo: Subscription Plan Clicked
//     properties:
//       next_plan_name:
//         mapTo: new_plan_name

exports.default = {
  $schema: 'http://json-schema.org/schema#',
  id: 'inboundTransforms',
  type: 'object',
  properties: {
    events: { $ref: '#/definitions/events' }
  },
  additionalProperties: false,

  // References
  definitions: {
    propertyMapping: {
      type: 'object',
      properties: {
        mapTo: { type: 'string' }
      },
      additionalProperties: false
    },
    eventMappingProperties: {
      type: 'object',
      additionalProperties: {
        $ref: '#/definitions/propertyMapping'
      },
      minProperties: 1
    },
    eventMapping: {
      type: 'object',
      properties: {
        mapTo: { type: 'string' },
        properties: { $ref: '#/definitions/eventMappingProperties' }
      },
      minProperties: 1,
      additionalProperties: false
    },
    events: {
      type: 'object',
      additionalProperties: { $ref: '#/definitions/eventMapping' },
      minProperties: 1
    }
  }
};
//# sourceMappingURL=inboundTransforms.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@segment/event-rules/build/inboundTransforms.js
// module id = 1044
// module chunks = 0